import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'faa-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css',
        '../../templates/4/assets/css/main.css'],
    standalone: false
})
export class FooterComponent implements OnInit {

  ngOnInit(): void {
  }

}